import React from "react";
import { Helmet } from "react-helmet";

const SITE_NAME = "León Gallery";
const DEFAULT_DESCRIPTION =
  "León Gallery is a leading Philippine art gallery and auction house presenting fine art, exhibitions, auctions, and collections.";

function getCanonicalUrl(canonical) {
  if (canonical) return canonical;
  if (typeof window === "undefined") return "";
  return `${window.location.origin}${window.location.pathname}`;
}

function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  canonical,
  image,
  type = "website",
  noindex = false,
  structuredData,
}) {
  const resolvedTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const resolvedCanonical = getCanonicalUrl(canonical);

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={description} />
      {resolvedCanonical && <link rel="canonical" href={resolvedCanonical} />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={description} />
      {resolvedCanonical && <meta property="og:url" content={resolvedCanonical} />}
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}

export default SEO;
